export const SET_LOCATION_SUGGESTIONS = 'SET_LOCATION_SUGGESTIONS';
export const RESET_LOCATION_SUGGESTIONS = 'RESET_LOCATION_SUGGESTIONS';
export const SET_POSTAL_CODE_SUGGESTIONS = 'SET_POSTAL_CODE_SUGGESTIONS';
export const FOUND_LISTING = 'FOUND_LISTING';
export const NO_LISTING_FOUND = 'NO_LISTING_FOUND';

// SINGLE LISTING
export const SET_LISTING = 'SET_LISTING';
export const RESET_LISTING_ASSETS = 'RESET_LISTING_ASSETS';
export const SET_LISTING_SUGGESTIONS = 'SET_LISTING_SUGGESTIONS';
export const SET_LOADING_LISTING = 'SET_LOADING_LISTING';
export const SET_LISTING_DEMOGRAPHICS = 'SET_LISTING_DEMOGRAPHICS';

// CONDOMINIUM PAGE
export const SET_CONDOMINIUM_SORTING = 'SET_CONDOMINIUM_SORTING';

//  FILTERS

// COMMON
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR_PAGE_DATA = 'SET_ERROR_PAGE_DATA';
export const SET_AUTOCOMPLETE_ERROR = 'SET_AUTOCOMPLETE_ERROR';
export const UNSET_AUTOCOMPLETE_ERROR = 'UNSET_AUTOCOMPLETE_ERROR';

// CONTACT FORM
export const SET_FORM_DATA = 'SET_FORM_DATA';
export const SET_FORM_RESULT = 'SET_FORM_RESULT';
export const SET_FORM_ERROR = 'SET_FORM_ERROR';
export const SET_FEEDBACK_FORM_DATA = 'SET_FEEDBACK_FORM_DATA';
export const SET_FEEDBACK_FORM_RESULT = 'SET_FEEDBACK_FORM_RESULT';
export const SET_FEEDBACK_FORM_ERROR = 'SET_FEEDBACK_FORM_ERROR';
export const SET_RENT_FORM_ERROR = 'SET_RENT_FORM_ERROR';

// AGENCIES AND AGENTS
export const SET_LOADING_AGENCIES = 'SET_LOADING_AGENCIES';

// PRICE CALCULATOR
export const SET_PRICE_PREDICTION = 'SET_PRICE_PREDICTION';
export const SET_PRICE_PREDICTION_LOADING = 'SET_PRICE_PREDICTION_LOADING';
export const SET_PRICE_PREDICTION_ERROR = 'SET_PRICE_PREDICTION_ERROR';

// ANALYTICS
export const analytics = {
  init: 'INIT_DATALAYER',
  set: 'SET_DATALAYER',
  saveString: 'SAVE_ANALYTICS_STRING',
  suspend: 'SET_ANALYTICS_SUSPENDED',
  ocmBannerReady: 'SET_OCM_BANNER_READY',
};
